import React from "react";
import BaseApi from "../../utils/BaseApi";
import Tooltip from "@mui/joy/Tooltip";
import {CircularProgress} from "@mui/joy";

//Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import Chip from "@mui/joy/Chip";
import UserSubscriberContext from "../../context/UserSubscriberContext";


class CommentRead extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            read_by: this.props.comment.read_by,
        };
    }

    async componentDidMount() {
        await setTimeout(
            this.postReadBy.bind(this),
            5000,
        )
    }

    async postReadBy() {
        const url = `comment/${this.props.comment.id}/read/`;
        const data = {
            'read_by': this.context.userObject.id
        };
        const api = new BaseApi();
        let response = await api.post(url, data);
        this.setState(
            {read_by: response.data.read_by}
        )
        this.props.callBack()
    }

    render() {
        if (!this.state.read_by) {
            return (
                <CircularProgress
                    size={'sm'}
                />
            )
        }
        return (
            <Tooltip
                title={
                    this.state.read_by.map((each) => {return(`${each.first_name} ${each.last_name}`)}).join(', ')
                }
                variant="soft"
            >
                <Chip
                    startDecorator={
                        <VisibilityIcon
                            fontSize='sm'
                        />
                    }
                    size="sm"
                >
                    {this.state.read_by.length}
                </Chip>
            </Tooltip>
        )
    }
}

export default CommentRead
